import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./DropOff.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import { FaRegWindowClose } from "react-icons/fa";
import { DropOffEntity } from "../../entities/DropOffEntity";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { LuImage,} from "react-icons/lu";
import { format } from "date-fns";
import { VendorDropoffService } from "../../services/vendors_dropoff";
import { FaRegCircleCheck } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";

export default function DropOffAccByAdmin() {
  // ========================================= GLOBAL CONTEXT =========================================  //
  const context = useContext(AppContext);
  const contextAccessToken = context.contextAccessToken;
  const contextShowAlertFunc = context.contextShowAlertFunc;
  const contextShowLoadingFunc = context.contextShowLoadingFunc;
  const stateShowLoading = context.stateShowLoading
  // ========================================= GLOBAL CONTEXT =========================================  //


  // ========================================= STATE VIEW =========================================  //
  // const [excludeFilter, setExcludeFilter] = useState();
  // const [tableDataFilter, setTableDataFilter] = useState({});

  const [tableData, setTableData] = useState<DropOffEntity[]>([]);

  const [selectedDropOff, setSelectedDropOff] = useState<DropOffEntity | null>(null);

  const [showPopup, setShowPopup] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState<number>(0);

  // ========================================= STATE VIEW =========================================  //

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  const handleDownloadFile = async () => {
    if (selectedDropOff == null || selectedDropOff?.penerima == null) return;
    try {
      const resp = await VendorDropoffService.GetFileVendorDropoff(selectedDropOff);
      const file_length = parseInt(resp.headers.get('Content-Length') ?? '0');
      const received = [];
      const reader = resp.body?.getReader()
      let progress = 0;
      while (true) {
        if (reader == undefined) break;
        const { done, value } = await reader.read();
        if (done) break;
        received.push(value);
        progress += value.length;
        setDownloadProgress(progress / file_length * 100)
      }
      const blob = new Blob(received, { type: resp.headers.get("Content-Type") ?? undefined });
      if (resp.status != 200) {
        contextShowLoadingFunc(false);
        return contextShowAlertFunc(new AlertEntity({ message: `[${resp.status}] Not found`, level: 3 }));
      }
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const file_name = (resp.headers.get("Content-disposition") ?? undefined).substring((resp.headers.get("Content-disposition") ?? undefined).indexOf('=') + 1);
      link.setAttribute('download', `${file_name}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      contextShowLoadingFunc(false);
      setDownloadProgress(0)
      return contextShowAlertFunc(new AlertEntity({ message: '[Success]', level: 1 }));
    } catch (error: any) {
      contextShowLoadingFunc(false);
      return contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
    }
  }
  const handlePopupDetail = (row: DropOffEntity) => {
    setSelectedDropOff(row);
    setShowPopup(true)
  }

  const handleAccept = (data: DropOffEntity, mark: "ACC" | "REJECT") => {
    if (data.status == "DONE") return
    return contextShowAlertFunc(new AlertEntity({
      message: `Apakah anda yakin ingin ${mark} Drop Off ke ${data.lokasi_drop_off} (${data.requestor}) ?`,
      onOk: async () => {
        contextShowLoadingFunc(true);
        try {
          const resp = await VendorDropoffService.AcceptOrRejectDropoff(data, mark);
          await generateData();
          contextShowLoadingFunc(false);
          setSelectedDropOff(null);
          setShowPopup(false);
          contextShowAlertFunc(new AlertEntity({ message: resp.message, level: 1 }));
        } catch (error: any) {
          contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
          contextShowLoadingFunc(false);
        }
      },
      withCancel: true,
      withOk: true,
      level: 2
    }))
  }

  const generateData = async () => {
    contextShowLoadingFunc(true);
    try {
      const resp = await VendorDropoffService.GetAllVendorDropoff();
      setTableData(resp);
      contextShowLoadingFunc(false);
    } catch (error: any) {
      contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
      contextShowLoadingFunc(false);
    }
  };

  useEffect(() => {
    generateData();
  }, [contextAccessToken]);

  // ========================================= FUNCTIONS =========================================  //
  // ========================================= FUNCTIONS =========================================  //

  return (
    <>
      <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
        <Card
          detailTitle="Drop Off ACC"
          detailColor="var(--secondary-color)"
          backgroundImage={backgroundCard}
          stateShow={true}
          detailCard={
            <>
              <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                {/* <div>
                  <div style={{ color: "white", textAlign: "start" }}>Action :</div>
                  <button className="cardButton" onClick={() => handleAddNew()} >
                    Add New
                  </button>
                </div> */}
              </div>
            </>
          }
        />
        <div
          style={{
            height: "65vh",
            overflow: "auto"
          }}>
          <table className="tableclickcell">
            {tableData.length > 0 ?
              <>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Tanggal</th>
                    <th>Shift</th>
                    <th>Vendor</th>
                    <th>Lokasi Drop Off</th>
                    <th>Requestor</th>
                    <th>Porsi Reguler</th>
                    <th>Porsi Vegetarian</th>
                    <th>Status</th>
                    <th colSpan={2}>Mark As</th>
                    <th>Foto</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => {
                    return <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{format(row.tanggal, "yyyy-MM-dd")}</td>
                      <td>{row.shift}</td>
                      <td>{row.vendor}</td>
                      <td>{row.lokasi_drop_off}</td>
                      <td>{row.requestor}</td>
                      <td>{row.porsi_reguler}</td>
                      <td>{row.porsi_vegetarian}</td>
                      <td style={{ display: "flex", flexDirection: "row" }}><span style={{ display: "flex", alignItems: "center", color: (row.status == "ACC" ? "#2593C9" : row.status == "DONE" ? "var(--header-color)" : row.status == "WAIT" ? "var(--secondary-color)" : "var(--bad-color)") }}><GoDotFill /></span>{row.status}</td>
                      <td className={(row.status == "DONE" ? undefined : "group-pick")} style={{ color: (row.status == "DONE" ? "black" : "var(--good-color)") }} onClick={() => { handleAccept(row, "ACC") }}><FaRegCircleCheck /></td>
                      <td className={(row.status == "DONE" ? undefined : "group-delete")} style={{ color: (row.status == "DONE" ? "black" : "var(--bad-color)") }} onClick={() => { handleAccept(row, "REJECT") }}><FaRegWindowClose /></td>
                      <td className="group-pick" onClick={() => { handlePopupDetail(row) }}><LuImage /></td>
                    </tr>
                  })}
                </tbody>
              </>
              :
              <>
                <thead><tr><th>no data available yet!</th></tr></thead>
              </>
            }
          </table>
        </div>

        {/* Popup Foto */}
        <Popup
          setShowPopup={setShowPopup}
          showPopup={showPopup}
          popupTitle={`Foto Drop Off Ke ${selectedDropOff?.lokasi_drop_off} (${selectedDropOff?.requestor})`}
          popupContent={
            <>
              <div className={css.form}>
                <div className={css.containerleftright}>
                  <div className={css.leftposition}><div className={css.label}> Bukti Foto <span style={{ color: "red" }}>*</span></div>
                    <button className={(selectedDropOff?.penerima ? "primaryButton" : "primaryButtonNoClick")} style={{ flexDirection: "column", justifyContent: "start", alignItems: "start" }}
                      onClick={async () => {handleDownloadFile()}} >
                      <div>
                        Download File
                      </div>
                      <div style={{ width: `${downloadProgress}%`, height: "2px", backgroundColor: "#17A8C5" }} />
                    </button>
                  </div>
                  <div className={css.rightposition}>
                    <div className={css.label}> Penerima <span style={{ color: "red" }}>*</span></div>
                    <input className={css.inputedit} type="text" value={selectedDropOff?.penerima ?? ""} readOnly style={{ backgroundColor: "silver" }} />
                  </div>
                </div>
                <div className={css.buttons2}>
                  <div className={css.left}>
                    <button className="tertiaryButton" onClick={() => { setShowPopup(false) }} >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </div>
    </>
  );
}
